import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { CreateShipmentReqBody, ShipmentEntity } from '../../../apis/dealsAPI'
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler'

import { DEALS_QUERY_KEY_ROOT } from './useDealsQuery'
import { dealQueryKey } from './useDealQuery'
import { shipmentsQueryKey } from './useShipmentsQuery'

interface CreateVariables {
  dealId: string
  body: CreateShipmentReqBody
}

export function useCreateShipmentMutation(): UseMutationResult<ShipmentEntity, unknown, CreateVariables> {
  const queryClient = useQueryClient()
  const handleError = useApiErrorHandler()

  return useMutation<ShipmentEntity, unknown, CreateVariables>(
    ({ dealId, body }) => dealsAPI.createShipment(dealId, body),
    {
      onSuccess: (_shipment, { dealId }) => {
        // Success toast is owned by the surrounding deal-update flow so a single
        // Save does not fan out into multiple toasts.
        queryClient.invalidateQueries({ queryKey: DEALS_QUERY_KEY_ROOT })
        queryClient.invalidateQueries({ queryKey: shipmentsQueryKey(dealId) })
        queryClient.invalidateQueries({ queryKey: dealQueryKey(dealId) })
      },
      onError: handleError,
    },
  )
}
